<template>
  <div id="c-loading" class="c-loading">
    <div class="c-loading__wrap">
      <img :src="`${$store.getters.assetsPath}img/common/logo@2x.png`" alt="999.9" width="109" height="62" />
      <p>NEW COLLECTION 2023-2024</p>
    </div>
    <div class="c-loading__bar"></div>
  </div>
</template>

<script>
import { gsap, Quart } from 'gsap';

export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    once() {
      gFNS.rootHTML.classList.add('is-load-end');
    },
    show() {
      gsap.fromTo(this.$el, {
        visibility: 'visible'
      }, {
        duration: 1.0,
        opacity: 1,
        ease: Quart.easeOut,
        onComplete: this.showComp
      });
    },
    showComp() {
      
    },
    hide() {
      gsap.to(this.$el, {
        duration: 1.0,
        opacity: 0,
        ease: Quart.easeOut,
        onComplete: this.hideComp
      });
    },
    hideComp() {
      this.$el.style.visibility = 'hidden';
    },
  }
}
</script>